import { ICreateRequisicaoCompraProdutoServicoUseCase } from "../../../presentation/useCases/create/create_requisicao_compra_produto_servico_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateRequisicaoCompraProdutoServicoUseCase
 */

export class CreateRequisicaoCompraProdutoServicoUseCase implements ICreateRequisicaoCompraProdutoServicoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createRequisicaoCompraProdutoServico(
    idRequisicaoCompra: number,
    idProdutoServico: number,
    idSubconta: number | null,
    quantidade: number,
  ): Promise<number> {
    return await this.repository.createRequisicaoCompraProdutoServico(
      idRequisicaoCompra,
      idProdutoServico,
      idSubconta,
      quantidade,
    );
  }
}
